import PropTypes from 'prop-types';

import Modal from 'components/Modal';

import 'components/provider/notifications/Notification.scss';
/**
 * This modal displays a welcome notification
 */
export default function WelcomeMessageModal(props) {
  const { notification, renderContainer } = props;
  return (
    <Modal
      title="Message"
      initialOpen
      transitionOpen="slide-in-up"
      transitionClose="slide-out-down"
      renderContainer={renderContainer}
    >
      <section className="expanded-notification">
        <div className="icon">
          <div className="styleseat-logo" />
        </div>
        <section className="notification-body">
          <p className="notification-text">
            <strong>
              {notification.title}.
            </strong>
            <span>
              {` ${notification.message} `}
            </span>
          </p>
          <p className="notification-time">
            <span>{`${moment(notification.creation_time).format('ddd MMM D')}`}</span>
            <span>&nbsp;&bull;&nbsp;</span>
            <span>{`${moment(notification.creation_time).format('h:mm A')}`}</span>
          </p>
        </section>
      </section>
    </Modal>
  );
}
WelcomeMessageModal.propTypes = {
  notification: PropTypes.object.isRequired,
  renderContainer: PropTypes.object,
};
